import { X, type LucideIcon, type LucideProps } from "lucide-react"

import DropoffPin from "./assets/dropoff.svg"
import PickupPin from "./assets/hail.svg"
import PerfectRidePin from "./assets/perfect-ride-stop.svg"

export type Icon = LucideIcon

export const Icons = {
  close: X,
  pageClose: (props: LucideProps) => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.8184 3L3.00043 18.818L4.41343 20.232L11.6282 13.0177L18.7712 20.1608L20.1862 18.7468L13.0427 11.6033L20.2324 4.414L18.8184 3ZM3.02513 4.414L4.43913 3L9.83413 8.395L8.42113 9.809L3.02513 4.414Z"
          fill={props.fill ?? "#081F42"}
        />
      </svg>
    )
  },
  pageBack: (props: LucideProps) => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.89 5L6.3 11.24H21V13.6H6.3L10.89 19.84H8.07L2.65 12.42L8.07 5H10.89Z"
          fill="#081F42"
        />
      </svg>
    )
  },
  spinner1: (props: LucideProps) => {
    return (
      <svg
        aria-hidden="true"
        viewBox="0 0 100 101"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
          fill="#ccc"
        />
        <path
          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
          fill="currentFill"
        />
      </svg>
    )
  },
  pinDropoff: (props: LucideProps) => {
    return <DropoffPin {...props} />
  },
  pinPickup: (props: LucideProps) => {
    return <PickupPin {...props} />
  },
  pinPerfectRide: (props: LucideProps) => {
    return <PerfectRidePin {...props} />
  },
  setting: (props: LucideProps) => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M19.7909 13.2108C19.8591 12.8108 19.8947 12.4058 19.8976 12C19.8947 11.5942 19.8591 11.1892 19.7909 10.7892L21.5409 9.09833C21.6744 8.96921 21.7609 8.79922 21.7867 8.61533C21.8125 8.43145 21.7762 8.24421 21.6834 8.08333L20.4334 5.91667C20.3394 5.75639 20.195 5.63176 20.0227 5.56226C19.8503 5.49275 19.6598 5.48229 19.4809 5.5325L17.1476 6.19917C16.5159 5.68461 15.8046 5.27622 15.0418 4.99L14.4559 2.63167C14.411 2.45131 14.307 2.29116 14.1605 2.17671C14.014 2.06225 13.8335 2.00005 13.6476 2H11.1476C10.9617 2.00005 10.7812 2.06225 10.6347 2.17671C10.4883 2.29116 10.3843 2.45131 10.3393 2.63167L9.75011 4.99C8.98842 5.27654 8.27834 5.68492 7.64761 6.19917L5.31427 5.5325C5.13537 5.48244 4.94493 5.49297 4.77263 5.56246C4.60034 5.63195 4.45588 5.75649 4.36177 5.91667L3.11177 8.08333C3.01884 8.2443 2.98238 8.43171 3.0082 8.61577C3.03402 8.79984 3.12064 8.96999 3.25427 9.09917L5.00427 10.79C4.93618 11.1898 4.90051 11.5945 4.89761 12C4.90046 12.4058 4.93614 12.8108 5.00427 13.2108L3.25427 14.9017C3.12083 15.0308 3.03434 15.2008 3.00853 15.3847C2.98271 15.5686 3.01905 15.7558 3.11177 15.9167L4.36177 18.0833C4.43498 18.2101 4.54031 18.3154 4.66715 18.3886C4.79398 18.4617 4.93786 18.5001 5.08427 18.5C5.16173 18.4997 5.23879 18.489 5.31344 18.4683L7.64677 17.8017C8.27852 18.3162 8.98975 18.7246 9.75261 19.0108L10.3418 21.3692C10.3868 21.549 10.4905 21.7086 10.6364 21.8229C10.7824 21.9371 10.9623 21.9994 11.1476 22H13.6476C13.8335 21.9999 14.014 21.9377 14.1605 21.8233C14.307 21.7088 14.411 21.5487 14.4559 21.3683L15.0451 19.01C15.8068 18.7235 16.5169 18.3151 17.1476 17.8008L19.4809 18.4675C19.5556 18.4882 19.6327 18.4988 19.7101 18.4992C19.8565 18.4993 20.0004 18.4609 20.1272 18.3877C20.2541 18.3146 20.3594 18.2093 20.4326 18.0825L21.6826 15.9158C21.7755 15.7549 21.812 15.5675 21.7862 15.3834C21.7604 15.1993 21.6737 15.0292 21.5401 14.9L19.7909 13.2108ZM12.3976 15.3333C11.7383 15.3333 11.0939 15.1378 10.5457 14.7716C9.99754 14.4053 9.5703 13.8847 9.31801 13.2756C9.06572 12.6665 8.9997 11.9963 9.12832 11.3497C9.25694 10.7031 9.57441 10.1092 10.0406 9.64298C10.5068 9.1768 11.1007 8.85933 11.7473 8.73072C12.3939 8.6021 13.0641 8.66811 13.6732 8.9204C14.2823 9.17269 14.8029 9.59994 15.1692 10.1481C15.5354 10.6963 15.7309 11.3407 15.7309 12C15.7309 12.8841 15.3798 13.7319 14.7546 14.357C14.1295 14.9821 13.2817 15.3333 12.3976 15.3333Z"
          fill="#3F4B53"
        />
      </svg>
    )
  },
  support: (props: LucideProps) => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M19.0685 4.91667C17.1558 3 14.661 2 11.9999 2C9.33879 2 6.84398 3 4.9313 4.91667C1.02278 8.83333 1.02278 15.1667 4.9313 19.0833C6.84398 21 9.33879 22 11.9999 22C14.661 22 17.1558 21 19.0685 19.0833C22.977 15.1667 22.977 8.83333 19.0685 4.91667ZM19.4012 15.8333L16.8232 13.25C16.9064 12.8333 16.9895 12.4167 16.9895 12C16.9895 11.5833 16.9064 11.1667 16.8232 10.75L19.4012 8.16667C20.6486 10.5833 20.6486 13.4167 19.4012 15.8333ZM4.59866 8.16667L7.17662 10.75C7.09346 11.1667 7.0103 11.5833 7.0103 12C7.0103 12.4167 7.09346 12.8333 7.17662 13.25L4.59866 15.8333C3.35126 13.4167 3.35126 10.5833 4.59866 8.16667ZM9.67143 14.3333C9.00615 13.75 8.6735 12.9167 8.6735 12C8.6735 11.0833 9.00615 10.25 9.67143 9.66667C10.2535 9 11.0851 8.66667 11.9999 8.66667C12.9147 8.66667 13.7463 9 14.3284 9.66667C14.9937 10.25 15.3263 11.0833 15.3263 12C15.3263 12.9167 14.9937 13.75 14.3284 14.3333C13.081 15.5833 10.9188 15.5833 9.67143 14.3333ZM15.8253 4.58333L13.2473 7.16667C12.8315 7.08333 12.4157 7 11.9999 7C11.5841 7 11.1683 7.08333 10.6693 7.16667L8.17454 4.58333C9.33879 4 10.6693 3.66667 11.9999 3.66667C13.3305 3.66667 14.661 4 15.8253 4.58333ZM8.17454 19.4167L10.7525 16.8333C11.1683 16.9167 11.5841 17 12.0831 17C12.582 17 12.9147 16.9167 13.4136 16.8333L15.9916 19.4167C14.8274 20 13.4968 20.3333 12.1662 20.3333C10.8357 20.3333 9.33879 20 8.17454 19.4167Z"
          fill="#3F4B53"
        />
      </svg>
    )
  },
  swapArrow: (props: LucideProps) => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M7.52965 2.35436C7.68929 2.16811 7.97742 2.16811 8.13706 2.35436L12.2673 7.17303C12.4898 7.4325 12.3054 7.83335 11.9636 7.83335H9.06668C8.84577 7.83335 8.66668 8.01243 8.66668 8.23335V15.7666C8.66668 15.9876 8.4876 16.1666 8.26668 16.1666H7.40002C7.17911 16.1666 7.00002 15.9876 7.00002 15.7666V8.23335C7.00002 8.01243 6.82094 7.83335 6.60002 7.83335H3.70306C3.36132 7.83335 3.17696 7.4325 3.39936 7.17303L7.52965 2.35436Z"
          fill="#3F4B53"
        />
        <path
          d="M16.6 7.83336C16.8209 7.83336 17 8.01244 17 8.23336V15.7667C17 15.9876 17.1791 16.1667 17.4 16.1667H20.2969C20.6387 16.1667 20.823 16.5675 20.6006 16.827L16.4703 21.6456C16.3107 21.8319 16.0226 21.8319 15.8629 21.6456L11.7326 16.827C11.5102 16.5675 11.6946 16.1667 12.0363 16.1667H14.9333C15.1542 16.1667 15.3333 15.9876 15.3333 15.7667V8.23336C15.3333 8.01244 15.5124 7.83336 15.7333 7.83336H16.6Z"
          fill="#3F4B53"
        />
      </svg>
    )
  },
  addLocation: (props: LucideProps) => {
    return (
      <svg
        width="16"
        height="20"
        viewBox="0 0 16 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M7.82609 0C3.97913 0 0 2.92696 0 7.82609C0 12.4252 6.91391 19.4461 7.2087 19.7435C7.37217 19.9078 7.59391 20 7.82609 20C8.05826 20 8.28 19.9078 8.44348 19.7435C8.73826 19.4461 15.6522 12.4252 15.6522 7.82609C15.6522 2.92696 11.673 0 7.82609 0ZM11.3043 8.69565H8.69565V11.3043H6.95652V8.69565H4.34783V6.95652H6.95652V4.34783H8.69565V6.95652H11.3043V8.69565Z"
          fill="#3F4B53"
        />
      </svg>
    )
  },
  poiInactive: (props: LucideProps) => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <circle cx="12" cy="12" r="10" fill="#3F4B53" />
        <path
          d="M11.8985 6.16675C9.66659 6.16675 7.33325 7.89139 7.33325 10.732C7.33325 13.4204 11.3912 17.5291 11.5434 17.6812C11.6448 17.7827 11.7463 17.8334 11.8985 17.8334C12.0506 17.8334 12.1521 17.7827 12.2535 17.6812C12.4057 17.5291 16.4637 13.4204 16.4637 10.732C16.4637 7.89139 14.1304 6.16675 11.8985 6.16675ZM11.8985 12.2537C11.0362 12.2537 10.3767 11.5943 10.3767 10.732C10.3767 9.86965 11.0362 9.21023 11.8985 9.21023C12.7608 9.21023 13.4202 9.86965 13.4202 10.732C13.4202 11.5943 12.7608 12.2537 11.8985 12.2537Z"
          fill="white"
        />
      </svg>
    )
  },
  poiPickup: (props: LucideProps) => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <circle cx="12" cy="12" r="12" fill="white" />
        <circle cx="12" cy="12" r="10" fill="#1A6CE5" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.25594 16.8904C6.62388 16.8904 6.95582 16.6716 7.10232 16.334C7.54484 15.3141 8.59224 13.2487 9.81738 13.2487L9.58562 13.9555C9.11122 15.4025 10.1892 16.8904 11.712 16.8904C12.6823 16.8904 13.5421 16.2649 13.8409 15.3417L14.8322 12.2785C16.491 11.8262 17.5997 10.2311 18.5856 7.99207C18.8605 7.36786 18.4016 6.66675 17.7195 6.66675C17.3495 6.66675 17.0124 6.88249 16.8596 7.21956C15.5234 10.1685 14.2895 10.9752 12.2054 11.1442C9.48053 11.3611 7.35896 11.5781 5.42702 15.5642C5.12991 16.1772 5.57481 16.8904 6.25594 16.8904ZM12.5636 10.5473C13.5188 10.5473 14.3546 9.77117 14.3546 8.81594C14.3546 7.801 13.5188 7.02495 12.5636 7.02495C11.6084 7.02495 10.8323 7.801 10.8323 8.81594C10.8323 9.77117 11.6084 10.5473 12.5636 10.5473Z"
          fill="white"
        />
      </svg>
    )
  },
  poiDropoff: (props: LucideProps) => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <rect width="24" height="24" rx="12" fill="white" />
        <circle cx="12" cy="12" r="12" fill="white" />
        <circle cx="12" cy="12" r="10" fill="#FFD200" />
        <path
          d="M7 10.4391C7 7.84826 9.23738 5.75 12 5.75C14.7626 5.75 17 7.84826 17 10.4391V10.4647C17 11.4626 16.6589 12.435 16.0252 13.2346L12.0409 18.25L8.00273 13.241C7.34789 12.435 7 11.4498 7 10.4391Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.5 10.0832C14.5 9.40164 14.0724 8.875 13.2993 8.875C12.7237 8.875 12.2796 9.12283 12 9.80437C11.7039 9.10734 11.2599 8.875 10.6842 8.875C9.91118 8.875 9.5 9.38615 9.5 10.0832C9.5 10.8886 9.94408 11.88 12 13.0417C14.0559 11.88 14.5 10.8731 14.5 10.0832Z"
          fill="#FFD200"
        />
      </svg>
    )
  },
  paymentMethod: (props: LucideProps) => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M11.9999 12.8333C12.9204 12.8333 13.6666 12.0871 13.6666 11.1667C13.6666 10.2462 12.9204 9.5 11.9999 9.5C11.0794 9.5 10.3333 10.2462 10.3333 11.1667C10.3333 12.0871 11.0794 12.8333 11.9999 12.8333Z"
          fill="#3F4B53"
        />
        <path
          d="M17.8333 5.33333V3.25C17.8333 2.56 17.2733 2 16.5833 2C15.8933 2 15.3333 2.56 15.3333 3.25V5.33333H14.5V3.25C14.5 2.56 13.94 2 13.25 2C12.56 2 12 2.56 12 3.25V5.33333H11.1667V3.25C11.1667 2.56 10.6067 2 9.91667 2C9.22667 2 8.66667 2.56 8.66667 3.25V5.33333H7.83333V3.25C7.83333 2.56 7.27333 2 6.58333 2C5.89333 2 5.33333 2.56 5.33333 3.25V5.33333H2V17H5.55167C6.2925 19.8742 8.89417 22 12 22C15.1058 22 17.7067 19.8742 18.4483 17H22V15.3333V5.33333H17.8333ZM20.3333 15.3333H18.6667V8.66667C16.8258 8.66667 15.3333 10.1592 15.3333 12V14.5C14.4933 14.5 13.7358 14.8208 13.15 15.3333C12 16.4008 11.5833 17.8592 11.5833 17.8592C11.5833 17.8592 11.1542 16.7758 11.3567 15.3333H3.66667V7H20.3333V15.3333Z"
          fill="#3F4B53"
        />
      </svg>
    )
  },
}
